import { UpdateKeyValueRequest } from "@models/base/updateKeyValueRequest.model"

export class UpdateTareaRequest extends UpdateKeyValueRequest{
  public titulo!:	string
  public fechaVencimiento!: Date | null
  public fechaInicioReal!: Date | null
  public fechaInicioEstimada!: Date | null
  public idEstadoTarea!:number
  public idTipoTarea!:number
  public idTareaPadre!:number
  public idExpediente!:number
  public asignadoA!:number
  public autorizadoPor!:number
  public prioridad!:number | null
  public nivelAvance!:number
  public notificado!:boolean
  }
